import React,{ useState,useContext,useEffect } from 'react'
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AuthButton } from './auth/AuthButton';
import { AuthContext } from './auth/AuthContext';

const Home = ({noaccess=false}) => {
    const {currentUser,customClaims } = useContext(AuthContext);
    console.log('currentUser', currentUser);
    return (
        <Stack justifyContent={"center"} alignItems="center" height="100vh" spacing={2} sx={{ bgcolor: '#f5f5f5' }}>
           <img src='/images/mattoboard-logo.png'  width={200} />
           <Typography  style={{marginBottom:'-10px'}} variant='caption'  letterSpacing={-0.5}>Design Firm Portal</Typography>
            <AuthButton setShowSubscription={null} />
            {noaccess && currentUser &&             
                <Stack justifyContent={"center"} alignItems="center" >
                <Typography  variant='caption' color="error" >
                    This account ({ (currentUser as any)?.email}) does not have access to the Design Firm Portal.  
                   </Typography>
                <Typography variant='caption' color="error" >
                    Please signout to login with a different account or email support@mattoboard.com for help.
                </Typography>
                </Stack>
            }
        </Stack>        
    )
}

export default Home;